import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})

/**
 * Filter an array of objects who have a value containing a specific substring
 */
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchstring: string): any[] {

    if (!items) { return []; }
    if (!searchstring) { return items; }

    return items.filter(item => {
      if (typeof item === "string") {
        return item.toLowerCase().includes(searchstring.toLowerCase().trim());
      } else {
        return Object.values(item).find(
          value => {
            return value.toString().toLowerCase().includes(searchstring.toLowerCase().trim());
          }
        );
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/filter.pipe.ts